<template>
  <a-drawer width="40%" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="接收人id" prop="receiveUserId">
        <a-input v-model="form.receiveUserId" placeholder="多个逗号隔开" />
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title">
        <a-input v-model="form.title" placeholder="请输入标题" />
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content">
        <a-textarea v-model="form.content" :rows="4" placeholder="请输入内容" />
      </a-form-model-item>
      <a-form-model-item label="业务类型" prop="bizType">
        <a-select
          v-model="form.bizType"
          placeholder="请选择业务类型"
          allow-clear
          style="width: 100%"
        >
          <a-select-option v-for="opt in bizTypeSelectOptions" :key="opt.value" :value="opt.value">
            {{ opt.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="业务主键id" prop="bizId">
        <a-input-number v-model="form.bizId" :min="0" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="优先级" prop="priority">
        <a-select v-model="form.priority" placeholder="请选择">
          <a-select-option :value="0">普通</a-select-option>
          <a-select-option :value="1">重要</a-select-option>
          <a-select-option :value="2">紧急</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="跳转路由"
        prop="routePath"
        extra="「去处理」仅按此处路径跳转，须与左侧菜单路由一致；业务主键 id 会附加到地址栏 query.id。"
      >
        <a-input v-model="form.routePath" placeholder="与系统菜单 path 一致，需以 / 开头" />
      </a-form-model-item>
      <a-form-model-item label="跳转参数JSON" prop="routeQuery" extra="解析为查询参数，会与 query.id（业务主键）合并。">
        <a-textarea v-model="form.routeQuery" :rows="2" placeholder="如 {&quot;status&quot;:&quot;0&quot;}" />
      </a-form-model-item>
      <a-form-model-item label="已读状态" prop="readStatus">
        <a-select v-model="form.readStatus" placeholder="请选择">
          <a-select-option :value="0">未读</a-select-option>
          <a-select-option :value="1">已读</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="已读时间" prop="readTime">
        <a-date-picker
          v-model="form.readTime"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          style="width: 100%"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="租户ID" prop="tenantId">
        <a-input-number v-model="form.tenantId" :min="0" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAnnouncement, addAnnouncement, updateAnnouncement } from '@/api/diandian/announcement'

const ANNOUNCEMENT_BIZ_TYPE_OPTIONS = [
  { value: 'real_name_authentication', label: '实名认证' },
  { value: 'user_cancellation', label: '用户注销' },
  { value: 'feedback', label: '意见反馈' },
  { value: 'profession_certification', label: '工种认证' },
  { value: 'enterprise_certification', label: '企业认证' },
  { value: 'master_withdrawal', label: '提现管理' }
]

export default {
  name: 'AnnouncementCreateForm',
  computed: {
    bizTypeSelectOptions () {
      const opts = [...ANNOUNCEMENT_BIZ_TYPE_OPTIONS]
      const v = this.form.bizType
      if (v && !opts.some(o => o.value === v)) {
        opts.unshift({ value: v, label: v })
      }
      return opts
    }
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      formType: 1,
      open: false,
      form: {
        id: null,
        receiveUserId: '',
        title: '',
        content: '',
        bizType: '',
        bizId: 0,
        priority: 0,
        routePath: '',
        routeQuery: '',
        readStatus: 0,
        readTime: null,
        tenantId: 0,
        remark: ''
      },
      rules: {
        receiveUserId: [{ required: true, message: '接收人id不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        receiveUserId: '',
        title: '',
        content: '',
        bizType: '',
        bizId: 0,
        priority: 0,
        routePath: '',
        routeQuery: '',
        readStatus: 0,
        readTime: null,
        tenantId: 0,
        remark: ''
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增业务审核公告'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAnnouncement({ id: id }).then(response => {
        const d = response.data || {}
        this.form = {
          id: d.id,
          receiveUserId: d.receiveUserId || '',
          title: d.title || '',
          content: d.content || '',
          bizType: d.bizType || '',
          bizId: d.bizId != null ? d.bizId : 0,
          priority: d.priority != null ? d.priority : 0,
          routePath: d.routePath || '',
          routeQuery: d.routeQuery || '',
          readStatus: d.readStatus != null ? d.readStatus : 0,
          readTime: d.readTime || null,
          tenantId: d.tenantId != null ? d.tenantId : 0,
          remark: d.remark || ''
        }
        this.open = true
        this.formTitle = '修改业务审核公告'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const payload = { ...this.form }
        if (payload.id) {
          updateAnnouncement(payload).then(() => {
            this.$message.success('修改成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          delete payload.id
          addAnnouncement(payload).then(() => {
            this.$message.success('新增成功', 3)
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
